import { SearchIcon } from '@chakra-ui/icons';
import { Container, Box, Image, Flex, Center } from '@chakra-ui/react';
import { Input, Visible } from 'components';
import { Profile } from 'components/Profile';
import { ChangeEvent, useEffect, useState } from 'react';
import { AiOutlineHeart } from 'react-icons/ai';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from 'utils';

const Header = () => {
  const history = useHistory();
  const location = useLocation();

  const [isSearchablePage, setIsSearchablePage] = useState(false);
  const [searchText, setSearchText] = useState('');
  const onWishlistClick = () => history.push(routes.WISHLIST.INDEX);

  useEffect(() => {
    setIsSearchablePage(location.pathname.includes(routes.WISHLIST.INDEX) ||location.pathname.includes(routes.ABOUT.INDEX));
  }, [location]);

  const onSearchInput = (event: ChangeEvent<HTMLSelectElement | HTMLInputElement>) => setSearchText(event.target.value)

  const onSearch = () => {
    console.log(searchText);
  };

  return (
    <Container maxW='container.xl'>
      <Flex paddingTop='24px' paddingBottom='24px' alignItems='center'>
        <Box>
          <Image src='../../ollie_logo.jpg' cursor='pointer' width={150} onClick={() => history.push(routes.INDEX)} />
        </Box>
        <Box flex={1}>
          <Visible when={isSearchablePage}>
            <Container
              padding={0}
              textAlign='center'
              maxWidth={430}
              height='40px'
              background='#FBFBFB'
              boxShadow='0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)'
              borderRadius='100px'>
              <Flex
                justifyContent='space-between' 
                background='#FBFBFB'>
                <Input
                  textAlign='center'
                  placeholder='Start your search'
                  onChange={onSearchInput}
                  borderTopRightRadius={0}
                  borderBottomRightRadius={0}
                />
                <Flex width='54px' justifyContent='center' height='46px'background='#3498FE' color='white' borderRadius='9999px'>
                  <SearchIcon w={6} h={6} cursor='pointer' onClick={onSearch} alignSelf='center' />
                </Flex>
              </Flex>
            </Container>
          </Visible>
        </Box>
        <Box>
          <Center backgroundColor='#FBFBFB' padding={3} borderRadius={'full'} shadow='lg' cursor='pointer'>
            <AiOutlineHeart color='#6F6F6F' size={18} onClick={onWishlistClick} />
          </Center>
        </Box>
        <Profile avatar='https://bit.ly/sage-adebayo' badgeCount={3} />
      </Flex>
    </Container>
  );
};

export { Header };
